import Vue from 'vue'
import Vuex from 'vuex'
import filters from '@/store/modules/filters'
import language from '@/store/modules/language'
import getters from './getters';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    filters,
    language
  },
  getters
})
